// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__27hqg","buttons":"Footer_buttons__1VgYO"};